import jsPDF from 'jspdf';
import { toast } from 'sonner';

export function generateJourneyPDF(report) {
  if (!report) return;
  try {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    let y = 20;

    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.text('My Journey Report', pageWidth / 2, y, { align: 'center' });
    y += 10;

    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text(report.participant.name, pageWidth / 2, y, { align: 'center' });
    y += 7;
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`${report.participant.days_in_program} days in program`, pageWidth / 2, y, { align: 'center' });
    y += 5;
    doc.text(`Generated: ${new Date(report.generated_at).toLocaleDateString()}`, pageWidth / 2, y, { align: 'center' });
    y += 12;

    doc.setFontSize(13);
    doc.setFont('helvetica', 'bold');
    doc.text('Journey Progress', 14, y);
    y += 8;
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`Life Milestones Achieved: ${report.journey_summary.total_milestones}`, 14, y); y += 6;
    doc.text(`Journey Completion: ${report.journey_summary.progress_percent}%`, 14, y); y += 6;
    doc.text(`Achievements Earned: ${report.achievements.length}`, 14, y); y += 10;

    const categories = report.journey_summary.milestones_by_category;
    if (Object.keys(categories).length > 0) {
      doc.setFont('helvetica', 'bold');
      doc.text('Milestones Achieved:', 14, y); y += 7;
      doc.setFont('helvetica', 'normal');
      Object.entries(categories).forEach(([, data]) => {
        if (y > 270) { doc.addPage(); y = 20; }
        doc.setFont('helvetica', 'bold');
        doc.text(`${data.name}:`, 16, y); y += 6;
        doc.setFont('helvetica', 'normal');
        data.milestones.forEach(m => {
          if (y > 270) { doc.addPage(); y = 20; }
          doc.text(`  - ${m.title} (${m.date})`, 20, y); y += 5;
        });
        y += 3;
      });
      y += 5;
    }

    if (y > 240) { doc.addPage(); y = 20; }
    doc.setFontSize(13);
    doc.setFont('helvetica', 'bold');
    doc.text('Program Engagement', 14, y); y += 8;
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`Total Check-ins: ${report.program_engagement.total_checkins}`, 14, y); y += 6;
    doc.text(`Sober Days Reported: ${report.program_engagement.sober_days_reported}`, 14, y); y += 6;
    doc.text(`Work Days Reported: ${report.program_engagement.work_days_reported}`, 14, y); y += 6;
    doc.text(`Roadmap Steps Completed: ${report.program_engagement.roadmap_milestones_completed}`, 14, y); y += 10;

    if (report.achievements.length > 0) {
      if (y > 240) { doc.addPage(); y = 20; }
      doc.setFontSize(13);
      doc.setFont('helvetica', 'bold');
      doc.text('Achievements Earned', 14, y); y += 8;
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      report.achievements.forEach(a => {
        if (y > 270) { doc.addPage(); y = 20; }
        doc.text(`  ${a.title} - ${a.date}`, 16, y); y += 6;
      });
      y += 5;
    }

    if (y > 260) { doc.addPage(); y = 20; }
    doc.setFontSize(8);
    doc.setFont('helvetica', 'italic');
    doc.text('This report reflects self-reported progress and program participation.', pageWidth / 2, 285, { align: 'center' });
    doc.text('Purpose Driven Peer Support Platform', pageWidth / 2, 290, { align: 'center' });

    doc.save(`Journey_Report_${report.participant.name.replace(/\s+/g, '_')}.pdf`);
    toast.success('PDF downloaded successfully!');
  } catch {
    toast.error('Failed to generate PDF');
  }
}
